<app-nav-bar></app-nav-bar>

<p>profile works!</p>

<app-footer></app-footer>